import { render, staticRenderFns } from "./ProductAddonMultiple.vue?vue&type=template&id=71d02791&scoped=true&"
import script from "./ProductAddonMultiple.vue?vue&type=script&lang=js&"
export * from "./ProductAddonMultiple.vue?vue&type=script&lang=js&"
import style0 from "./ProductAddonMultiple.vue?vue&type=style&index=0&id=71d02791&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71d02791",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCheckbox,VCol,VContainer,VIcon,VRow})
